import type { TLngLat } from 'App/Map/types'
import { ExternalVendorIcons } from 'components/ExternalVendorIcons/ExternalVendorIcons'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import type { TPropertyId } from 'stores/fieldAssetStore/helperTypes'

export const PointVendorIcons = ({ propertyId, lngLat }: { propertyId: TPropertyId; lngLat: TLngLat }) => {
  const externalVendorNames = fieldAssetStore.useSelector(
    (s) => s.properties?.[propertyId]?.points?.[lngLat]?.externalVendorNames,
  )

  if (!externalVendorNames?.length) return null

  return <ExternalVendorIcons externalVendorNames={externalVendorNames} size={20} />
}
